// extracted by mini-css-extract-plugin
export default {"skipTable":"ImportSkipDetailDialog_skipTable__r1mwO"};